import React from "react";
import {
    Alert,
    Button,
    Card,
    CardActions,
    CardContent,
    CardHeader,
    Stack,
    Typography,
} from "@mui/material";
import SwapHorizRoundedIcon from "@mui/icons-material/SwapHorizRounded";

export default function SubscriptionCard({
    userInfo,
    planDescription,
    paidUntilDisplay,
    cancellationRequested,
    cancellationDateDisplay,
    onOpenPlanDialog,
    onOpenCancelDialog,
}) {
    return (
        <Card sx={{ borderRadius: 3, boxShadow: "0 8px 28px rgba(0,0,0,0.06)" }}>
            <CardHeader title="Abonnement" subheader="Plan, Laufzeit und Kündigung" />
            <CardContent>
                <Stack direction={{ xs: "column", md: "row" }} spacing={3}>
                    <Stack spacing={1} flex={1}>
                        <Stack spacing={0.5}>
                            <Typography variant="subtitle2" color="text.secondary">
                                Tarif
                            </Typography>
                            <Typography variant="body1">{planDescription}</Typography>
                        </Stack>
                        <Stack spacing={0.5}>
                            <Typography variant="subtitle2" color="text.secondary">
                                Bezahlt bis
                            </Typography>
                            <Typography variant="body1">{paidUntilDisplay}</Typography>
                        </Stack>
                        {cancellationRequested && (
                            <Alert severity="warning" variant="outlined">
                                Kündigung zum {cancellationDateDisplay} vorgemerkt.
                                {userInfo?.cancellationReason && (
                                    <>
                                        <br />
                                        Grund: {userInfo.cancellationReason}
                                    </>
                                )}
                            </Alert>
                        )}
                    </Stack>
                </Stack>
            </CardContent>
            <CardActions sx={{ justifyContent: "flex-end", px: 3, py: 2, gap: 1 }}>
                <Button
                    variant="contained"
                    startIcon={<SwapHorizRoundedIcon />}
                    onClick={onOpenPlanDialog}
                    disabled={!userInfo}
                >
                    Abo ändern
                </Button>
                <Button
                    variant="outlined"
                    color="error"
                    onClick={onOpenCancelDialog}
                    disabled={cancellationRequested || !userInfo}
                >
                    Abo kündigen
                </Button>
            </CardActions>
        </Card>
    );
}
